// frontend/src/components/RouteErrorBoundary.jsx
//
// An ErrorBoundary that forgets the error when you navigate somewhere else.
//
// A boundary holds its error in state, so without this a crash on /sales-orders
// would keep showing the error panel after clicking through to Leads — the
// boundary never re-renders its children again. Keying it on the pathname
// remounts it on every navigation, which clears the state.
//
// Placed around <Routes> rather than around each page: one wrapper covers every
// route, and because it sits INSIDE <Layout>, the sidebar and header stay alive
// and clickable while the content area shows the failure.
import React from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

export default function RouteErrorBoundary({ children }) {
  const { pathname } = useLocation();
  return <ErrorBoundary key={pathname}>{children}</ErrorBoundary>;
}
